<template>
  <v-dialog v-model="missingDialog" persistent max-width="1300">
    <v-card class="mx-auto">
      <v-card-title>
        <v-text-field
          v-model="search"
          prepend-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-1"
          :search.sync="search"
        >
          <template v-slot:item.action="{ item }">
            <v-btn color="primary" @click="addRatePlan(item)">
              Add Rule
            </v-btn>
          </template>
        </v-data-table>
        <v-card-actions class="mt-1">
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog">close</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
    <add-rule ref="addRule" @init="fetchAllMissing"></add-rule>
    <!-- <v-row v-show="addPlan">
      <v-col>
      </v-col>
    </v-row> -->
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import RatePlan from '@/models/RatePlan'
import ruleDetail from '@/components/commissions/ruleDetail'
import addRule from "@/components/commissions/AddRule";

export default {
  name: 'MissingPlans',
  components: {
    ruleDetail,
    addRule
  },
  props: {
    missingDialog: Boolean
  },
  data() {
    return {
      dialog: false,
      runType: 1,
      search: null,
      items: [],
      rules: [],
      editedItem: {},
      headers: [
        {
          text: 'Description',
          value: 'servicePlanDescription',
          align: 'left',
          sortable: true,
          class: ['strong']
        },
        {
          text: 'Rate Plan ID',
          value: 'servicePlanNo',
          align: 'left',
          sortable: true,
          class: ['strong']
        },
        {
          text: 'Group Name',
          value: 'groupName',
          align: 'left',
          sortable: true,
          class: ['strong']
        },
        {
          text: 'Actions',
          value: 'action',
          align: 'left',
          sortable: false,
          width: 100,
          class: ['strong']
        }
      ]
    }
  },

  watch: {
    missingDialog(val) {
      if (val == true) {
        this.fetchAllMissing()
      }
      return val
    }
  },
  methods: {
    ...mapActions('commissions', ['CommissionsRequest']),
    fetchAllMissing() {
      let query = {
        message: `Get Rate Plans With No Rules`,
        url: `Commissions/GetRatePlansWithNoRules`,
        method: 'get',
        body: this.editedItem
      }
      this.CommissionsRequest(query)
        .then((data) => {
          this.items = data
        })
        .catch(() => {})
    },
    addRatePlan(val) {
      this.$refs.addRule.populate(val);
    },
    closeDialog(){
      this.items = [];
      this.search = null;
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped></style>
